export default __webpack_public_path__ + "static/media/biy-energy-logo-left-nav.fb293996.png";